import { render, staticRenderFns } from "./TheMainMenuItem.vue?vue&type=template&id=493c0faa&scoped=true"
import script from "./TheMainMenuItem.vue?vue&type=script&lang=js"
export * from "./TheMainMenuItem.vue?vue&type=script&lang=js"
import style0 from "./TheMainMenuItem.vue?vue&type=style&index=0&id=493c0faa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493c0faa",
  null
  
)

export default component.exports